export default {
  common: {
    login: "登录",
    loginRequired: "请登录后继续。",
    logout: "登出",
    signup: "注册",
    home: "首页",
    search: "搜索",
    cancel: "取消",
    confirm: "确认",
    save: "保存",
    delete: "删除",
    edit: "编辑",
    welcome: "欢迎",
    loading: "加载中...",
    error: "发生错误",
    noData: "暂无数据",
    number: "编号",
    title: "标题",
    date: "日期",
    type: "类型",
    status: "状态",
    canceled: "已取消",
    approved: "已批准",
    rejected: "已拒绝",
    waiting: "等待中",
    reset: "重置",
    submit: "提交",
    success: "成功",
    failed: "失败",
    amountMustBeGreaterThan0: "金额必须大于0",
  },
  header: {
    announcement: "已经开始了！",
    login: "登录",
    register: "注册",
    casino: "真人娱乐场",
    slotGame: "老虎机游戏",
    liveSports: "体育博彩",
    cashIn: "存款",
    cashOut: "提款",
    needHelp: "需要帮助",
    honorific: "先生/女士",
    chip: "筹码",
    point: "积分",
    partnerPage: "合作伙伴页面",
  },
  slider: {
    casino: {
      subtitle: "SHOGUN LIVE CASINO",
      title1: "真人娱乐场",
      title2: "我们保证所有玩家的满意度",
    },
    slot: {
      subtitle: "SHOGUN SLOT GAME",
      title1: "在线老虎机",
      title2: "我们保证所有玩家的满意度",
    },
    sports: {
      subtitle: "SHOGUN SPORTS",
      title1: "体育博彩",
      title2: "我们保证所有玩家的满意度",
    },
  },
  homePage: {
    casino: {
      title: "真人娱乐场",
      subtitle: "SHOGUN CASINO",
    },
    slot: {
      title: "老虎机",
      subtitle: "SHOGUN SLOT",
    },
  },
  gameList: {
    showAll: "显示全部",
    underMaintenance: "正在维护中。",
  },
  board: {
    faq: {
      subtitle: "常见问题",
      title: "FAQ",
      viewMore: "查看更多FAQ",
      items: [
        {
          id: 1,
          title: "'SHOGUN'是什么样的公司？",
          content: "'SHOGUN'是一个提供在线赌场和移动赌场服务的全球游戏平台。我们24小时全天候运营，提供100多种不同的赌场游戏。"
        },
        {
          id: 2,
          title: "网站安全吗？",
          content: "是的，SHOGUN采用最新的安全系统来保护会员的个人信息和资产。所有交易都经过加密处理，我们定期进行审计以确保公平的游戏环境。"
        },
        {
          id: 3,
          title: "游戏种类多吗？",
          content: "是的，SHOGUN提供100多种不同的游戏。您可以享受各种类型的游戏，包括真人娱乐场、老虎机游戏和迷你游戏。特别是在渐进式累积奖池游戏中，您可以赢得大奖。"
        },
        {
          id: 4,
          title: "存款和提款怎么样？",
          content: "SHOGUN支持多种存取款方式。您可以使用银行转账、加密货币（USDT）等便捷方式。存款在5-10分钟内处理完成。"
        }
      ]
    },
    notice: {
      subtitle: "公告",
      title: "最新公告",
      viewMore: "查看更多公告",
    },
  },
  footer: {
    ourPartners: "我们的合作伙伴",
    copyright: "版权所有 2024 SHOGUN. 保留所有权利",
    casino: "真人娱乐场",
    slotGame: "老虎机游戏",
    miniGame: "迷你游戏",
  },
  auth: {
    login: "登录",
    register: "注册",
    username: "用户名",
    password: "密码",
    passwordConfirm: "确认密码",
    passwordMismatch: "密码不匹配",
    rememberPassword: "记住密码",
    captcha: "请输入验证码",
    referrer: "推荐代码",
    phone: "电话号码",
    nameBank: "银行名称",
    numberBank: "账户号码",
    userBank: "账户持有人",
    loginFailed: "登录失败",
    registerFailed: "注册失败",
  },
  maintenance: {
    title: "我们很快就会回来！",
    message: "系统维护中。给您带来不便，敬请谅解。",
  },
  homePopup: {
    selectList: "选择列表",
    deposit: "存款",
    withdrawal: "提款",
    bankingHistory: "银行交易历史",
    pointToChip: "积分转换",
    notice: "公告",
    inquiry: "咨询",
    myInfo: "我的信息",
    betHistory: "投注历史",
    faq: "常见问题",
  },
  betting: {
    name: "投注名称",
    game: "游戏",
    type: "类型",
    amount: "金额",
    date: "日期",
    status: {
      win: "赢",
      lose: "输",
      bet: "投注",
    },
  },
  deposit: {
    notice: "请仔细确认存款信息",
    info: "存款将在5-10分钟内处理",
    currentBalance: "当前余额",
    amount: "存款金额",
    usdtAmount: "USDT存款金额",
    requestAccount: "请求存款账户",
    requestUsdtAddress1: "Polygon USDT Address",
    requestUsdtAddress2: "Tron USDT Address",
    myWallet: "我的钱包",
    bottomNotice: "如需帮助请联系客服",
    title: "存款",
    normalDeposit: "普通存款",
    usdtDeposit: "USDT存款",
  },
  withdrawal: {
    notice: "请仔细确认提款信息",
    currentBalance: "当前余额",
    walletAddress: "钱包地址",
    amount: "提款金额",
    usdtAmount: "USDT提款金额",
    password: "提款密码",
    myWallet: "我的钱包",
    title: "提款",
    normalWithdrawal: "普通提款",
    usdtWithdrawal: "USDT提款",
  },
  banking: {
    bankAccountRequired: "请输入银行账户信息",
  },
  bankinghistory: {
    beforeBalance: "存款前余额",
    requestAmount: "申请金额",
    afterBalance: "存款后余额",
  },
  notice: {
    unread: "未确认",
    read: "已确认",
  },
  inquiry: {
    title: "咨询标题",
    select: "选择咨询类型",
    writer: "提交人",
    placeholder: "请输入咨询内容（最多100字）",
    types: {
      deposit: "存款咨询",
      withdrawal: "提款咨询",
      account: "存款账户申请",
      other: "其他咨询",
    },
    question: "问题",
    answer: "回答",
    status: "状态",
    pending: "等待回复",
    inProgress: "回复中",
    completed: "回复完成",
    unknown: "未知",
    empty: "暂无咨询",
    reply: "回复",
    send: "发送",
    note: "等待回复",
    showMore: "显示更多",
    showLess: "显示更少",
    newInquiry: "新咨询",
    delete: "删除",
    deleteConfirmation: "确定要删除此咨询吗？",
  },
  profile: {
    username: "用户名",
    balance: "余额",
    point: "积分",
    changePassword: "修改密码",
    currentPassword: "当前密码",
    newPassword: "新密码",
    confirmPassword: "确认密码",
    passwordChanged: "密码修改成功",
    passwordMismatch: "密码不匹配",
    invalidPassword: "当前密码不正确",
  },
  point: {
    currentBalance: "当前积分",
    amount: "兑换金额",
    enterAmount: "请输入金额",
    password: "密码",
    enterPassword: "请输入密码",
    convert: "兑换",
    invalidAmount: "无效金额",
    convertSuccess: "积分兑换成功",
  },
}; 